import {
	fullVideoHlsSource,
	type HlsClipSource,
} from "@ui/molecules/VideoPreview/useHlsSource";
import type { VideoEvidence } from "../ChatEventTypes";

/**
 * HLS for evidence whose `video_url` is its whole source video, so its
 * `start_time`/`end_time` are source-absolute: the *whole-video* manifest,
 * not one for just the clip's range. A clip-range manifest is cut at segment
 * boundaries and starts its own timeline at 0, so the player's absolute clip
 * bounds would land in the wrong place; the whole-video one keeps the source
 * timeline, so those bounds apply unchanged. Loading still starts at the clip
 * (attachHlsClip's startPosition), not at the video's opening segments.
 *
 * Undefined without `source_video_id`, which only producers of whole-video
 * evidence set, or when the server says there is no package to play (both
 * in ChatEventTypes).
 */
export const videoEvidenceHlsSource = (
	evidence: VideoEvidence,
): HlsClipSource | undefined =>
	evidence.hls_ready === false
		? undefined
		: fullVideoHlsSource(evidence.source_video_id, evidence.video_duration);
